"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.betEpics = void 0;
var _types = require("./types");
var _reduxObservable = require("redux-observable");
var _operators = require("rxjs/operators");
var _rxjs = require("rxjs");
var _actions = require("./actions");
var _types2 = require("../balance/types");
var _types3 = require("../com/types");
var _RoundState = require("../enums/RoundState");
var _types4 = require("../blitz/types");
var _types5 = require("../game/types");
var _types6 = require("../promotion/types");
var _types7 = require("../autoPlay/types");
var _currencyFormatter = require("../../../utils/currencyFormatter");
var _PromotionType = require("../../common/enums/PromotionType");
var _CommandType = require("../../dovahzul/CommandType");
var _types8 = require("../featureBuy/types");
var _logger = _interopRequireDefault(require("../../../utils/logger"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var denomMinusPlus = function denomMinusPlus(action$, store) {
  return action$.pipe((0, _reduxObservable.ofType)(_types.DENOM_MINUS, _types.DENOM_PLUS), (0, _operators.filter)(function (a) {
    if (a.type === _types.DENOM_PLUS && store.value.bet.denominations.indexOf(store.value.bet.denomination) == store.value.bet.denominations.length - 1 || a.type === _types.DENOM_MINUS && store.value.bet.denominations.indexOf(store.value.bet.denomination) == 0 || !store.value.bet.betChangeAllowed) return false;
    return true;
  }), (0, _operators.mergeMap)(function (a) {
    var denoms = store.value.bet.denominations;
    var nextDenom;
    if (a.type === _types.DENOM_MINUS) {
      nextDenom = denoms.indexOf(store.value.bet.denomination) > 0 ? denoms.indexOf(store.value.bet.denomination) - 1 : 0;
    } else {
      nextDenom = denoms.indexOf(store.value.bet.denomination) < denoms.length - 1 ? denoms.indexOf(store.value.bet.denomination) + 1 : denoms.length - 1;
    }
    return (0, _rxjs.of)({
      type: _types.UPDATE_BET,
      payload: {
        denomination: denoms[nextDenom]
      }
    });
  }));
};
var denomToggle = function denomToggle(action$, store) {
  return action$.pipe((0, _reduxObservable.ofType)(_types.DENOM_TOGGLE), (0, _operators.filter)(function (a) {
    return store.value.bet.betChangeAllowed;
  }), (0, _operators.mergeMap)(function (a) {
    var denoms = store.value.bet.denominations;
    var nextDenom = denoms.indexOf(store.value.bet.denomination) < denoms.length - 1 ? denoms.indexOf(store.value.bet.denomination) + 1 : 0;
    return (0, _rxjs.of)({
      type: _types.UPDATE_BET,
      payload: {
        denomination: denoms[nextDenom]
      }
    });
  }));
};
var formatBetEpic = function formatBetEpic(action$, store) {
  return action$.pipe((0, _reduxObservable.ofType)(_types.UPDATE_BET, _types.COINS_MINUS, _types.COINS_PLUS, _types.DENOM_MINUS, _types.DENOM_PLUS, _types2.UPDATE_BALANCE), (0, _operators.filter)(function () {
    return !!store.value.balance.currency;
  }), (0, _operators.mergeMap)(function (a) {
    var action = (0, _actions.updateFormattedBet)((0, _currencyFormatter.currencyFormatter)(store.value.bet.denomination * store.value.bet.lines * store.value.bet.coins, store.value.balance.currency, store.value.config.locale, undefined, true));
    return (0, _rxjs.of)(action);
  }));
};

/**
 * Gets fired by GameConfigurationResponse
 * @param action$ 
 * @returns 
 */
var setDefaultBet = function setDefaultBet(action$) {
  return action$.pipe((0, _reduxObservable.ofType)(_types.SET_DEFAULT_BET), (0, _operators.mergeMap)(function (a) {
    if (a.payload.denominations.indexOf(a.payload.denomination) < 0) {
      _logger["default"].warn("The default denomination is not in the list of denominations. We will set it to the first in the list.");
      a.payload.denomination = a.payload.denominations[0];
    }
    // do magic adjustment of default bet.
    return (0, _rxjs.of)({
      type: _types.UPDATE_BET,
      payload: {
        denomination: a.payload.denomination,
        denominations: a.payload.denominations,
        baseDenominations: a.payload.denominations,
        featureBuyDenominations: a.payload.featureBuyDenominations,
        blitzDenominations: a.payload.blitzDenominations
      }
    });
  }));
};

/**
 * For blitz specific denom. THis is to reset it to something is always allowed
 * 
 * @param action$ 
 * @param store 
 * @returns 
 */
var toggleBetModes = function toggleBetModes(action$, store) {
  return action$.pipe((0, _reduxObservable.ofType)(_types8.TOGGLE_FEATURE_BUY, _types5.ROUND_END, _types5.ROUND_VOID), (0, _operators.filter)(function () {
    return !store.value.promotion.on;
  }),
  // PROMOTIONS CAN HAVE DENOMS NOT ALLOWED IN NONE PROMOS, LIKE slot gf has 0.05 in promo, but not in normal play.
  (0, _operators.mergeMap)(function (a) {
    var denominations = store.value.featureBuy.showDialog ? store.value.bet.featureBuyDenominations : store.value.bet.baseDenominations;
    var denomination = store.value.bet.denomination;

    // the current denomination is not allowed by the current list of denominations.
    if (!(denominations.indexOf(denomination) >= 0)) {
      // we assume this is due to lower allowed denoms in the new set. Its a bit of a hack. we set to lowest bet.
      denomination = denominations[0];
    }
    return (0, _rxjs.of)({
      type: _types.UPDATE_BET,
      payload: {
        denominations: denominations,
        denomination: denomination
      }
    });
  }));
};
var resetToDefaultBet = function resetToDefaultBet(action$, store) {
  return action$.pipe((0, _reduxObservable.ofType)(_types6.PROMOTION_END), (0, _operators.mergeMap)(function (a) {
    return (0, _rxjs.of)({
      type: _types.UPDATE_BET,
      payload: {
        denomination: store.value.bet.defaultDenomination
      }
    });
  }));
};
var commandSetBet = function commandSetBet(action$) {
  return action$.pipe((0, _reduxObservable.ofType)(_types3.COMMAND_RECEIVED), (0, _operators.filter)(function (a) {
    return _CommandType.CommandType.SetBetResponse === a.payload.type;
  }), (0, _operators.switchMap)(function (a) {
    return (0, _rxjs.of)({
      type: _types.UPDATE_BET,
      payload: {
        denomination: a.payload.denomination,
        lines: a.payload.payLines,
        coins: a.payload.coins,
        featureSet: a.payload.featureSet
      }
    });
  }));
};

/**
 * Allow or disallow bet to be adjust. allows of controlling bet change enabled/disabled from one single state in the store.
 *
 * @param action$
 * @param store
 */
var betCanBeChanged = function betCanBeChanged(action$, store) {
  return action$.pipe((0, _reduxObservable.ofType)(_types4.BLITZ_PLAY_STOP, _types4.BLITZ_PLAY_START, _types7.AUTO_PLAY, _types7.AUTO_PLAY_STOP, _types6.PROMOTION_START, _types6.PROMOTION_END, _types5.ROUND_START, _types5.ROUND_END, _types5.ROUND_VOID), (0, _operators.switchMap)(function (a) {
    if (store.value.game.roundState == _RoundState.RoundState.Started || !!store.value.promotion.on || store.value.autoPlay.on || !!store.value.blitz.playing || !!store.value.blitz.paused) {
      return (0, _rxjs.of)({
        type: _types.BET_CHANGE_DISABLE
      });
    }
    return (0, _rxjs.of)({
      type: _types.BET_CHANGE_ENABLE
    });
  }));
};

/**
 * Validate feature change request, ensuring its allowed at the time.
 *
 * @param action$
 * @param store
 */
var featureSetRequest = function featureSetRequest(action$, store) {
  return action$.pipe((0, _reduxObservable.ofType)(_types.REQUEST_BET_FEATURE_SET), (0, _operators.filter)(function () {
    return !(store.value.game.roundState == _RoundState.RoundState.Started ||
    // we allow changeing Feature set for free spins, but no other promotion type
    // TODO handle if it was actually set.
    !!store.value.promotion.on && store.value.promotion.type != _PromotionType.PromotionType.FreeGames ||
    // if promo is locked to a feature set we block change.
    !!store.value.promotion.on && store.value.promotion.lockedFeatureSet || store.value.autoPlay.on || !!store.value.blitz.playing || !!store.value.blitz.paused);
  }),
  //store.value.bet.betChangeAllowed),
  (0, _operators.mergeMap)(function (a) {
    return (0, _rxjs.of)({
      type: _types.UPDATE_BET_FEATURE_SET,
      payload: a.payload
    });
  }));
};
var betEpics = exports.betEpics = (0, _reduxObservable.combineEpics)(formatBetEpic, setDefaultBet, commandSetBet, denomMinusPlus, betCanBeChanged, denomToggle, featureSetRequest, resetToDefaultBet, toggleBetModes);

/**
 *
 *
 *
 * {
type: 'UPDATE_BALANCE',
payload:{
balance:{centValue:0},
bonusBalance:{centValue:0},
currency:'EUR'
}
}
 */
//# sourceMappingURL=epics.js.map